import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from './base-api.service';
import { HomeMetricasResponse } from '../interfaces/home-metricas.interface';
import { HomeGraficoMensalResponse } from '../interfaces/home-grafico-mensal.interface';
import { HomeGraficoPercentualResponse } from '../interfaces/home-grafico-percentual.interface';

@Injectable({
  providedIn: 'root'
})
export class DashboardService extends BaseApiService {

getLeadsHomeSegmentos(codigoDn: string, dataIni?: string, dataFim?: string): Observable<any[]> {
  let endpoint = `/lead/home/segmentos?dn=${codigoDn}`;

  // Adicionar datas apenas se ambas forem fornecidas
  if (dataIni && dataFim) {
    endpoint += `&dataIni=${dataIni}&dataFim=${dataFim}`;
  }

  if (this.configService.isDebugEnabled()) {
    console.log('DashboardService - getLeadsHomeSegmentos endpoint:', endpoint);
  }
  return this.get<any[]>(endpoint);
}

  getLeadsHomeSegmentosDataOnly(codigoDn: string): Observable<any> {
    return this.getLeadsHomeSegmentos(codigoDn).pipe(
      map(response => response[0]) // Remove o .data
    );
  }

getHomeMetricas(codigoDn: string, dataIni?: string, dataFim?: string): Observable<HomeMetricasResponse> {
  let endpoint = `/lead/home/metricas?dn=${codigoDn}`;

  // Adicionar datas apenas se ambas forem fornecidas
  if (dataIni && dataFim) {
    endpoint += `&dataIni=${dataIni}&dataFim=${dataFim}`;
  }

  return this.get<HomeMetricasResponse>(endpoint);
}

  getHomeGraficoMensal(codigoDn: string): Observable<HomeGraficoMensalResponse> {
    const endpoint = `/lead/home/grafico-mensal?dn=${codigoDn}`;
    return this.get<HomeGraficoMensalResponse>(endpoint);
  }

getHomeGraficoPercentual(codigoDn: string, dataIni?: string, dataFim?: string): Observable<HomeGraficoPercentualResponse> {
  let endpoint = `/lead/home/grafico-percentual?dn=${codigoDn}`;

  // Adicionar datas apenas se ambas forem fornecidas
  if (dataIni && dataFim) {
    endpoint += `&dataIni=${dataIni}&dataFim=${dataFim}`;
  }

  if (this.configService.isDebugEnabled()) {
    console.log('DashboardService - getHomeGraficoPercentual endpoint:', endpoint);
  }
  return this.get<HomeGraficoPercentualResponse>(endpoint);
}

exportHomeLeadsExcel(codigoDn: string, dataIni?: string, dataFim?: string): Observable<HttpResponse<Blob>> {
  let endpoint = `/lead/home/export-excel?dn=${codigoDn}`;

  if (dataIni && dataFim) {
    endpoint += `&dataIni=${dataIni}&dataFim=${dataFim}`;
  }

  const url = `${this.getBaseUrl()}${endpoint}`;

  return this.getHttpClient().get(url, {
    headers: this.getAuthHeaders(),
    responseType: 'blob',
    observe: 'response'
  });
}
}
